import { FC, useCallback, useState } from "react";
import { useEffect } from "react";
import {
  ColorValue,
  NativeSyntheticEvent,
  StyleProp,
  StyleSheet,
  Text,
  TextInput,
  TextInputFocusEventData,
  TextStyle,
  View,
  ViewStyle,
} from "react-native";
import { kStyleConst } from "src/kStyle";

type tUnit = {
  label: string;
  location: "start" | "end";
  style?: TextStyle;
};
export interface tNumberInputProps {
  value?: string;
  placeholder?: string;
  placeholderTextColor?: ColorValue;
  onBlur?: (e: NativeSyntheticEvent<TextInputFocusEventData>) => void;
  onFocus?: (e: NativeSyntheticEvent<TextInputFocusEventData>) => void;
  onChangeNumber?: (myNumber: number) => void;
  onInputNumber?: (myNumber: number) => void;
  onChangeText?: (myText: string) => void;
  unit?: tUnit;
  maxLength?: number;
  style?: StyleProp<ViewStyle>;
  textInputStyle?: TextStyle | Array<TextStyle>;
  editable?: boolean;
}

const NumberInput: FC<tNumberInputProps> = ({
  value = "",
  placeholder = "",
  placeholderTextColor,
  onBlur,
  onFocus,
  onChangeNumber,
  onInputNumber,
  onChangeText,
  unit,
  maxLength,
  style,
  textInputStyle,
  editable = true,
}) => {
  const [sValue, _setValue] = useState(value);

  useEffect(() => {
    _setValue(value);
  }, [value]);

  const _onChangeText = useCallback(
    (myValue: string) => {
      if (/^[0-9]*\.?[0-9]*$/gm.test(myValue)) {
        if (myValue.charAt(0) === "0" && myValue.length > 1) {
          myValue = myValue.substring(1);
        } else if (myValue.length === 0) {
          myValue = "0";
        }
        if (!maxLength || myValue.length < maxLength) {
          _setValue(myValue);
          if (onChangeNumber) onChangeNumber(Number.parseFloat(myValue));
          if (onChangeText) onChangeText(myValue);
        }
      }
    },
    [maxLength, onChangeText, onChangeNumber],
  );

  const _handleOnBlur = useCallback(
    (e: NativeSyntheticEvent<TextInputFocusEventData>) => {
      if (onBlur) onBlur(e);
      if (onInputNumber) onInputNumber(Number.parseFloat(sValue));
    },
    [onBlur, onInputNumber, sValue],
  );

  return (
    <View style={[style, styles.gNumberInputView]}>
      {!!unit && unit.location === "start" && (
        <Text style={[styles.gNumberInputStartUnit, unit.style]}>{unit.label}</Text>
      )}
      <TextInput
        editable={editable}
        style={[styles.gNumberInputTextInput, textInputStyle]}
        placeholder={placeholder}
        placeholderTextColor={placeholderTextColor}
        onBlur={_handleOnBlur}
        onFocus={onFocus}
        maxLength={maxLength}
        // selection={sSelection}
        onChangeText={_onChangeText}
        value={sValue}
      />
      {!!unit && unit.location === "end" && <Text style={[styles.gNumberInputEndUnit, unit.style]}>{unit.label}</Text>}
    </View>
  );
};

export default NumberInput;

const styles = StyleSheet.create({
  gNumberInputEndUnit: {
    marginStart: kStyleConst.kSpacing,
  },
  gNumberInputStartUnit: {
    marginEnd: kStyleConst.kSpacing,
  },
  gNumberInputTextInput: {
    flex: 1,
    minWidth: 0,
  },
  gNumberInputView: {
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
    overflow: "hidden",
  },
});
